import { Route } from "react-router";
import { useEffect, useState } from "react";
import "./App.css";
import Login from "./pages/login/login";
import { Routes, useNavigate } from "react-router";
import AccessDenied from "./components/auth/AccessDenied";
import Dashboard from "./pages/dashboard/dashboard";
import PrivateWrapper from "./data/PrivateWrapper";
import { NoPage } from "./pages/404/NoPage";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import useTransientStore from "./data/transcientStore";
import AddressSelection from "./pages/addressSelection/AddressSelection";
import { AUTH_ENABLED } from "./data/authConfig";
// import { notifications } from '@mantine/notifications';

function App() {
  const msalIsAuthenticated = useIsAuthenticated();
  const { accounts } = useMsal();
  const isAuthenticated = AUTH_ENABLED ? msalIsAuthenticated : true;
  const navigate = useNavigate();
  const setToken = useTransientStore((state) => state.setToken);
  const [tokenUpdated, setTokenUpdated] = useState(false);

  useEffect(() => {
    if (!AUTH_ENABLED) {
      setToken("dev-no-auth");
      setTokenUpdated(true);
      return;
    }
    if (isAuthenticated) {
      const bearerToken = accounts.length > 0 ? accounts[0].idToken : null;
      if (process.env.DEV) {
        console.log("Bearer ", bearerToken); //This is needed for easy copy paste for swagger
      }

      if (
        bearerToken === null ||
        bearerToken === undefined ||
        bearerToken === ""
      ) {
        navigate("/");

        // notifications.show({
        // 	title: 'No token found',
        // 	message: 'No token found in the account, redirecting to login',
        // 	color: 'red',
        // 	withBorder: true
        // });
      } else {
        setToken(bearerToken as string);
        setTokenUpdated(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, accounts]);

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/access-denied" element={<AccessDenied />} />

      <Route
        path="/select-address-system"
        element={
          <PrivateWrapper>
            <AddressSelection />
          </PrivateWrapper>
        }
      />

      <Route
        path="/dashboard"
        element={
          <PrivateWrapper>
            <Dashboard />
          </PrivateWrapper>
        }
      />

      <Route path="*" element={<NoPage />} />
    </Routes>
  );
}

export default App;
